import * as Yup from 'yup'

export const ProfileUpdateStatusSchemas = Yup.object().shape({
  newStatusId: Yup.string().nullable(),
})
